import Route from '@ember/routing/route';
import { next } from '@ember/runloop';
import { service } from '@ember/service';

import type { APIData, Service } from 'webapp-types';

export default class RequestTrialRoute extends Route {
	@service('account') declare accountService: Service.Account;
	@service('billing') declare billingService: Service.Billing;
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('logger') declare loggerService: Service.Logger;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('popup') declare popupService: Service.Popup;
	@service('request') declare requestService: Service.Request;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	override beforeModel(): Promise<unknown> {
		if (
			this.currentUserService.isPowerUser ||
			this.accountService.hasPartnerResellerId ||
			!this.currentUserService.isAdmin
		) {
			this.navigationService.transitionToRoute('index');
			return Promise.resolve();
		}

		this.billingService.isRequestSecondTrialInProgress = true;

		return this.navigationService.initialRequestsPromise;
	}

	override model(): void {
		let transitionRouteName = 'index';
		const popup = this.navigationService.createFullscreenLoaderModal();
		popup.open();

		this.requestService
			.api<APIData.Account.SecondTrialResponse>('POST', '/account/secondtrial')
			.then(
				(response) => {
					const hasSecondTrialStarted = response.startSecondTrialSuccessfully;
					transitionRouteName = 'settings.billing.index';

					next(() => {
						this.billingService.openSecondTrialPopup(hasSecondTrialStarted);
					});
				},
				(error) => {
					if (error?.code) {
						this.loggerService.logError('[Second Trial] Problem getting data.', {
							error: JSON.stringify(error),
						});
					}

					throw error;
				},
			)
			.finally(() => {
				void popup.close();
				this.navigationService.transitionToRoute(transitionRouteName);
			})
			.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
	}
}
